import { useIsCurrentPageType } from '@avensia/excite';

export function useCurrentPageIsCheckoutPage() {
  const isCheckout = useIsCurrentPageType<NordicNest.Api.CheckoutPageApiModel>();
  const isExpressCheckout = useIsCurrentPageType<NordicNest.Api.ExpressCheckoutPageApiModel>();
  return isCheckout || isExpressCheckout;
}
